import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableResetPassword = withAsyncLoading(async () =>
    import('./ResetPasswordPage').then((res) => res.ResetPasswordPage)
);

export { LoadableResetPassword };
